module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-crop', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "url": _vm.uploadUrl,
      "field": _vm.fileName,
      "img-format": "png"
    },
    on: {
      "crop-upload-success": _vm.uploadSuccess
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-81788f10!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/about/CropUpload.vue
// module id = 1094
// module chunks = 0